import './App.css';
import { Analytics } from '@vercel/analytics/react';
import React from 'react';
import Home from './components/Home/home';
import About from './components/About/about';
import Project from './components/Projects/projects';
import Contact from './components/Contact/contact';
import Navbar from './components/Navbar/navbar';
import Footer from './components/Footer/footer';
import WorkHistory from './components/WorkHistory/WorkHistory';

function App() {
  return (
    <div className="App dark bg-bg text-ink">
      <header className="App-header">
        <Navbar />
        <main className="w-full">
          <Home />
          <About />
          <WorkHistory />
          <Project />
          <Contact />
        </main>
        <Footer />
        <Analytics />
      </header>
    </div>
  );
}

export default App;
